import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-99d2f3d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "flex items-center" }, "PDF Export", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "h-px my-4 bg-gray-200 border-0 dark:bg-gray-700" }, null, -1))
const _hoisted_3 = { class: "flex flex-col gap-3" }
const _hoisted_4 = { class: "w-full mb-3 text-center" }
const _hoisted_5 = { class: "pb-4 text-lg font-medium leading-6 text-gray-900" }
const _hoisted_6 = { class: "flex justify-center" }
const _hoisted_7 = { class: "grid grid-cols-2 gap-8" }
const _hoisted_8 = { class: "w-full border-t py-5 text-center" }
const _hoisted_9 = { class: "pb-4 text-lg font-medium leading-6 text-gray-900" }
const _hoisted_10 = { class: "flex justify-center" }
const _hoisted_11 = { class: "grid grid-cols-2 gap-8" }
const _hoisted_12 = { class: "flex pt-4 gap-2 justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_RadioGroupLabel = _resolveComponent("RadioGroupLabel")!
  const _component_RadioGroupOption = _resolveComponent("RadioGroupOption")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_mainButton = _resolveComponent("mainButton")!
  const _component_ModalTW = _resolveComponent("ModalTW")!

  return (_openBlock(), _createBlock(_component_ModalTW, {
    open: _ctx.open,
    onOnCloseModal: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('canceled'))),
    customCls: "sm:w-1/4"
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t("analytics.planner.events")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_RadioGroup, {
              modelValue: _ctx.rowsRange,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rowsRange) = $event)),
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rowsRangeList, (option) => {
                    return (_openBlock(), _createBlock(_component_RadioGroupOption, {
                      as: "template",
                      key: option,
                      value: option
                    }, {
                      default: _withCtx(({ checked }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass([
                      checked
                        ? 'relative border-yellow-600 text-yellow-600 hover:bg-yellow-600 hover:text-white'
                        : 'border-gray-200 bg-white text-gray-900 hover:bg-gray-50',
                      'focus:outline-non flex cursor-pointer items-center justify-center rounded-md border px-8 py-3 text-sm sm:flex-1',
                    ])
                        }, [
                          _createVNode(_component_CheckCircleIcon, {
                            class: _normalizeClass([
                        !checked ? 'invisible' : '',
                        'absolute left-0 top-0 h-5 w-5 text-yellow-600',
                      ]),
                            "aria-hidden": "true"
                          }, null, 8, ["class"]),
                          _createVNode(_component_RadioGroupLabel, { as: "span" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(`analytics.planner.${option}`)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t("analytics.planner.items")), 1),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_RadioGroup, {
              modelValue: _ctx.scheduleRange,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.scheduleRange) = $event)),
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduleRangeList, (option) => {
                    return (_openBlock(), _createBlock(_component_RadioGroupOption, {
                      as: "template",
                      key: option,
                      value: option
                    }, {
                      default: _withCtx(({ checked }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass([
                      checked
                        ? 'relative border-yellow-600 text-yellow-600 hover:bg-yellow-600 hover:text-white'
                        : 'border-gray-200 bg-white text-gray-900 hover:bg-gray-50',
                      'focus:outline-non flex cursor-pointer items-center justify-center rounded-md border px-8 py-3 text-sm sm:flex-1',
                    ])
                        }, [
                          _createVNode(_component_CheckCircleIcon, {
                            class: _normalizeClass([
                        !checked ? 'invisible' : '',
                        'absolute left-0 top-0 h-5 w-5 text-yellow-600',
                      ]),
                            "aria-hidden": "true"
                          }, null, 8, ["class"]),
                          _createVNode(_component_RadioGroupLabel, { as: "span" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(`analytics.planner.${option}`)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_mainButton, {
          class: "sm:-mr-0",
          label: _ctx.$t('buttons.cancel'),
          type: "button",
          bordered: "true",
          onClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('canceled')))
        }, null, 8, ["label"]),
        _createVNode(_component_mainButton, {
          class: "hover:bg-orange sm:-mr-0",
          label: _ctx.$t('buttons.export_plain'),
          type: "button",
          color: "yellow",
          onClick: _ctx.confirm
        }, null, 8, ["label", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}